const AVATAR_COLORS = ["#5E4DB2", "#D2691E", "#2E7D32", "#1565C0", "#AD1457", "#00838F", "#EF6C00", "#6D4C41"];

/** Deterministic color per name, so the same person always gets the same avatar color. */
export function avatarColor(name) {
  if (!name) return "#9E9E9E";
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function initials(name) {
  if (!name) return "?";
  return name.trim().split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("");
}
